import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App.tsx';
import ErrorBoundary from './components/common/ErrorBoundary';
import { initTheme } from './utils/theme';
import { initPerfMode } from './utils/perfMode';

// Apply the saved/system theme + wire the OS "system" listener. First paint is
// already handled by the inline script in index.html (no flash); this keeps the
// runtime in sync for everyone, signed in or not.
initTheme();

// Decide the adaptive performance mode (strips backdrop-filter / heavy blurs /
// ambient animations on CPU-composited or weak devices). The persisted/software
// decision is applied pre-paint by the inline script in index.html; this adds
// the runtime FPS refinement and keeps the decision in sync.
initPerfMode();

const globalContext = globalThis as Record<string, unknown>;
if (typeof globalContext.__PROP_VISION_API_BASE_URL !== 'string') {
  globalContext.__PROP_VISION_API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
